import { Tabs } from "../../UserTabs";

export const TABS = {
  POSTS: "Posts",
  LIKED: "Liked",
  SAVED: "Saved",
  REVIEWS: "Reviews",
  SERVICES: "Services",
  STYLISTS: "Stylists",
};

export const BaseTabs = {
  Posts: TABS.POSTS,
  Liked: TABS.LIKED,
  Saved: TABS.SAVED,
};

export const UserTabs = {
  ...BaseTabs,
  Reviews: TABS.REVIEWS,
};

export const StylistTabs = {
  ...BaseTabs,
  Services: TABS.SERVICES,
};

export const SalonTabs = {
  ...BaseTabs,
  Services: TABS.SERVICES,
  Stylists: TABS.STYLISTS,
};

const types = {
  [Tabs.Users]: UserTabs,
  [Tabs.Stylists]: StylistTabs,
  [Tabs.Salons]: SalonTabs,
};

export function UserDetailsTabs({ selectedTab, setSelectedTab, values, type }) {
  const DetailsTabs = types[type];
  return (
    <div className="p-1 mx-10 rounded-[10px] border border-[#d7d7d7] justify-start items-center gap-px flex">
      {Object.values(DetailsTabs).map((tab) => (
        <button
          onClick={() => setSelectedTab(tab)}
          key={tab}
          className={`flex-1 px-3.5 py-2 w-20 hover:bg-black/20 hover:text-white ${
            selectedTab === tab ? "!bg-black text-white" : "text-black"
          } rounded-lg poppins  text-sm font-medium justify-center items-center gap-2.5 flex`}
        >
          {tab}
          {values[tab] ? `(${values[tab]})` : ""}
        </button>
      ))}
    </div>
  );
}
